<h1 mat-dialog-title>DELETE SONG</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveSongCancel()">CANCEL</button>
  <button mat-button [ngClass]="{'hidden': canDelete==false}"  (click)="removeSong(song)" cdkFocusInitial>YES</button>
</div>